'use client'

import React from 'react'
import { useTravelComparatorStore } from '@/app/stores/travel/travel-comparator.store'
import { destinationOptionsFor, RESIDENCE_OPTIONS, today } from '../travelFormConfig'
import CountryCell from './CountryCell'
import TravelDateRangeField from './TravelDateRangeField'
import TravelersCell from './TravelersCell'

// Mobile puts destination and dates first on full rows; desktop keeps residence beside destination
export default function TravelTripFields() {
    const { form, patchForm } = useTravelComparatorStore()

    return (
        <div className="grid grid-cols-2 gap-2.5 sm:gap-3">
            <div className="order-3 min-w-0 sm:order-1">
                <CountryCell
                    label="Pays de résidence"
                    mobileLabel="Résidence"
                    placeholder="Votre pays"
                    value={form.residenceCountry}
                    options={RESIDENCE_OPTIONS}
                    onChange={(code) => patchForm({ residenceCountry: code })}
                />
            </div>
            <div className="order-1 col-span-2 min-w-0 sm:order-2 sm:col-span-1">
                <CountryCell
                    label="Destination"
                    placeholder="Où allez-vous ?"
                    value={form.destinationCountries[0] ?? ''}
                    options={destinationOptionsFor(form.motif)}
                    onChange={(code) => patchForm({ destinationCountries: [code] })}
                />
            </div>
            <div className="order-2 col-span-2 min-w-0 sm:order-3 sm:col-span-1">
                <TravelDateRangeField
                    startDate={form.startDate}
                    endDate={form.endDate}
                    minDate={today()}
                    onChange={(startDate, endDate) => patchForm({ startDate, endDate })}
                />
            </div>
            <div className="order-4 min-w-0">
                <TravelersCell />
            </div>
        </div>
    )
}
